// Detalle de un producto elegido: «Chaise L Izq · 254 cm · Como · Negro ·
// Patas: Negras · Con arcón». Las etiquetas de las opciones las pone el back al
// sincronizar el catálogo (server/lib/detalleProducto.js) y llegan hechas en
// `opciones`: aquí solo se une, para que el panel diga lo mismo que el pedido y
// el contrato.

const SEPARADOR = ' · ';

export function unirDetalle(partes) {
  return partes
    .map((parte) => (parte == null ? '' : String(parte).trim()))
    .filter(Boolean)
    .join(SEPARADOR);
}

function opciones(p) {
  return Array.isArray(p?.opciones) ? p.opciones : [];
}

/** Medida, largo, tapizado, color y las opciones de la variante. */
export function detalleProducto(p) {
  if (!p) return '';
  return unirDetalle([p.medida, p.largo, p.tapizado, p.color, ...opciones(p)]);
}

/** Segunda línea de una variante en el buscador: tapizado, color y opciones. */
export function detalleVariante(v) {
  if (!v) return '';
  return unirDetalle([v.tapizado, v.color, ...opciones(v)]);
}
